// Assets que viajan dentro del HTML de los correos.
//
// El logo era `https://production-habit.s3.amazonaws.com/habit/Habit+Logo.png`, escrito a mano en
// 8 lugares: un objeto público del bucket de habit, en la Cuenta B. Con una cuenta por app ese
// bucket se apaga y los correos ya enviados se quedan sin logo, así que la referencia tiene que
// salir de ahí. Copiarlo al bucket de addco no sirve: ese bucket es privado y no tiene por qué
// dejar de serlo para servir una imagen. Y no hace falta — la propia app ya sirve estáticos, y de
// hecho ya sirve su propio logo.
//
// Se arma con `window.location.origin` y no con `endpoints.app_url` a propósito. El correo se
// compone en el navegador, así que el origin es el host que en ese momento está sirviendo la app:
// no puede estar mal. `app_url` sale de una variable de Amplify que hoy vale
// `https://addco.addval.io`, que es un 301 de Apache en hosting externo.
//
// El que se manda es `/logo-new.png`, el logo propio de la app: el mismo que ya se ve en la barra
// de navegación y en las pantallas de login. Lo que había en S3 era el logo verde de habit, aunque
// el alt del correo dijera "AddCo Logo", así que esto además corrige lo que el correo mostraba.
export const LOGO_CORREO = `${window.location.origin}/logo-new.png`
